export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}user/nps/:id`;
    return $resource(url, null, {
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/UserNps/index.js